import { PagePending } from "@/components/ui/PagePending";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/members/$memberId/new-claim")({
  pendingComponent: PagePending,
  beforeLoad: () => ({
    breadcrumb: "New Claim",
  }),
  component: lazyRouteComponent(() => import("./+NewClaimPage")),
  head: () => ({ meta: seo({ title: "Submit Claim for Member" }) }),
});
